<template>
    <div :class="$style.root">
        <!-- <h1>欢迎登录无人机电力巡线系统</h1> -->
        <h2>Welcome to Sign in</h2>
        <div class="formContainer">
            <div class="wrapper">
                <a-tabs default-active-key="pwd">
                    <a-tab-pane tab="密码登录" key="pwd">
                        <FormPwdLogin />
                    </a-tab-pane>

                </a-tabs>
            </div>
        </div>
    </div>
</template>

<script>
    import FormPwdLogin from './components/FormPwdLogin.vue';

    export default {
        name: 'LoginView',

        components: { FormPwdLogin },
    };
</script>

<style lang="less" module>
    .root {
        position: relative;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        &::before {
            content: '';
            // position: absolute;
            // left: 0;
            // right: 0;
            // top: 0;
            // bottom: 40%;
            // // background: url(../../assets/login-bg.jpg) no-repeat scroll center top transparent;
            // background-size: cover;
        }

        &::after {
            content: '';
            // position: absolute;
            // left: 0;
            // right: 0;
            // top: 0;
            // bottom: 40%;
            // background-color: rgba(black, 0.2);
        }

        h1 {
            font-size: 50px;
            font-weight: 400;
            color: #fff;
            line-height: 1;
            letter-spacing: 0.4em;
            text-indent: 0.4em;
            text-shadow: 0 0 10px rgba(0, 0, 0, 0.18);
            margin-bottom: 24px;
            position: relative;
            z-index: 1;
        }

        h2 {
            font-size: 22px;
            font-weight: 300;
            color: #fff;
            line-height: 1;
            letter-spacing: 0.3em;
            margin-bottom: 80px;
            position: relative;
            z-index: 1;
        }

        :global {
            .formContainer {
                position: relative;
                width: 640px;
                height: 430px;
                background-color: #fff;
                z-index: 1;

                &::before,
                &::after {
                    content: '';
                    width: 70%;
                    height: 55%;
                    box-shadow: 0 15px 20px 5px rgba(0, 0, 0, 0.11);
                    position: absolute;
                    bottom: 25px;
                    z-index: -1;
                }

                &::before {
                    transform: skew(-15deg) rotate(-6deg);
                    left: 25px;
                }

                &::after {
                    transform: skew(15deg) rotate(6deg);
                    right: 25px;
                }

                .wrapper {
                    width: 100%;
                    height: 100%;
                    background-color: #fff;
                    box-shadow: 0 1px 9px rgba(0, 0, 0, 0.18), 0 0 40px rgba(0, 0, 0, 0.06) inset;
                    padding-top: 20px;

                    .ant-input-prefix i {
                        font-size: 24px;
                        margin-left: -3px;
                    }

                    .ant-input-prefix + .ant-input {
                        padding-left: 36px;
                    }

                    .ant-input-group-addon {
                        padding: 0;
                        background-color: white;
                        cursor: pointer;
                    }

                    .columns {
                        display: flex;
                        align-items: center;
                        margin-bottom: 20px;

                        .column,
                        .whitespace {
                            flex: 1;
                        }

                        .column + .whitespace {
                            flex: none;
                            width: 10px;
                        }
                    }
                }
            }

            .ant-tabs-bar {
                border-bottom-color: #E6E6E6;

                .ant-tabs-nav-scroll {
                    text-align: center;
                    font-size: 16px;
                }
            }
        }
    }
</style>
